import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageDo0011 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    grsMultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireCriteres: IFormulaire;
}

/* @ngInject */
export default function Do0011Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    MenuItemForage: IMenuItemForageClass,
    do0016Route: IRoute,
    do0017Route: IRoute
) {
    const vm: IPageDo0011 = this;

    vm.formulaireDo = new Formulaire('LBL_DO', [
        new FormulaireItem('grgcod', {
            largeur: 33
        }),
        new FormulaireItem('grgdscabr', {
            largeur: 33
        }),
        new FormulaireItem('vaegrgtyp', {
            largeur: 33
        }),
        new FormulaireItem('grgdsc', {
            largeur: 66
        }),
        new FormulaireItem('rglcleint', {
            largeur: 33
        }),
        new FormulaireGroupeAccordeon('LBL_SEL', new Formulaire([
            new FormulaireItem('bqecleintsld', {
                largeur: 25
            }),
            new FormulaireItem('grgbqesldmin', {
                largeur: 25
            }),
            new FormulaireItem('grgbqesldmax', {
                largeur: 25
            }),
            new FormulaireItem('vaegrgorisldsel', {
                largeur: 25
            }),
            new FormulaireItem('grgflginsobl', {
                largeur: 33,
                menu: [new MenuItemForage(
                    'LBL_INSCRIPTION',
                    do0016Route.NAME,
                    (data: any) => ({
                        grgcleint: data.grgcleint
                    }),
                    {
                        hidden: (data: any) => !data.grgflginsobl
                    }
                )]
            }),
            new FormulaireItem('grgflgdespos', {
                largeur: 33,
                menu: [new MenuItemForage(
                    'LBL_DESINSCRIPTION',
                    do0017Route.NAME,
                    (data: any) => ({
                        grgcleint: data.grgcleint
                    }),
                    {
                        hidden: (data: any) => !data.grgflgdespos
                    }
                )]
            }),
            new FormulaireItemDivider('LBL_EMP'),
            new FormulaireItem('grgflgaut', {
                largeur: 33
            }),
            new FormulaireItem('grgflgemp', {
                largeur: 33
            })
        ])),
        new FormulaireGroupeAccordeon('LBL_ORDRE', new Formulaire([
            new FormulaireItem('vaegrgtyptri', {
                largeur: 33
            }),
            new FormulaireItem('bqecleinttri', {
                largeur: 33
            }),
            new FormulaireItem('vaegrgorisld', {
                largeur: 33
            })
        ]))
    ]);

    vm.grsMultiOccurrenceOptions = {
        bloc: 'grs',
        colonnesVisibles: [
            { nom: 'grsseq', largeur: 110 },
            { nom: 'urgcod', largeur: 110 },
            { nom: 'urgdscabr', largeur: 110 },
            { nom: 'strcod', largeur: 110 },
            { nom: 'strdsc', largeur: 110 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('grsseq', {
                largeur: 33
            }),
            new FormulaireItem('urgcleint', {
                largeur: 33
            }),
            new FormulaireItem('strcleint', {
                largeur: 33,
                resourceParams: (data: any) => ({ urgcleint: data.urgcleint })
            })
        ])
    }

}
